<template>
  <div class="d-flex align-center">
    <v-icon
      v-if="icon"
      class="mr-2"
      :color="small ? '#fe9a00' : 'black'"
      :size="small ? 18 : 22"
    >
      {{ `mdi-${icon}` }}
    </v-icon>

    <div :class="['font-weight-bold', fontSize]">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    title: String,
  },
  computed: {
    fontSize() {
      const size = {
        true: "text-body-1",
      };

      return size[this.small] || "text-h6";
    },
  },
};
</script>
